var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-task-reassign',{staticClass:"pt-task-reassign__page"})
}
var staticRenderFns = []

export { render, staticRenderFns }